import React from "react";

import range from "lodash/range";

import MenuItemSkeleton from "../MenuItemSkeleton";
import styles from "./MenuRowSkeleton.scss";

export default function MenuRowSkeleton(): JSX.Element {
  return (
    <div className={styles.row}>
      {range(3).map((key) => (
        <MenuItemSkeleton key={key} className={styles.item} />
      ))}
    </div>
  );
}
